var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../libs/Model');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var dragscroll = require('../libs/dragscroll');
var modalForm = require('../layout/components/modalForm');
var modal = require('../layout/components/modal');
var buttonElement = require('../components/button');
var heading = require('../components/heading');
var halfGridItem = require('../components/halfGridItem');
var pointTd = require('../data/components/pointTd');
var paginationWithSearch = require('./components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');


var Aggregate = Object.create(Model);

Object.assign(Aggregate, require('../../../../models/data/aggregate'));

var aggregateModal = modalForm(Aggregate);

var page = {};

page.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Aggregates';
  header.vm.activeTab('Aggregates');
  ctrl.newNode = prop(false);
  
  ctrl.init = function () {
    return loaders.requestWithLoader({
      url: "/api/v1/aggregate/",
      method: "GET"
    })
    .then(function(result){
      ctrl.aggregates = result;
      ctrl.newNode(true);
    }); 
  };
  ctrl.aggregatesToShow = [];
  modal.on('closed', ctrl.init)
  ctrl.init();
};

page.onremove = function () {
  modal.off('closed', this.init);
}

page.view = function () {
  var ctrl=this
  if(!ctrl.aggregates){
    return m('div')
  }
  return m('div.mh3', [
    m(heading, {label: 'Aggregates', class: 'f-subheadline mb3 pb1 display'}, [
      edit.vm.editing() ? m(rowActionDropdown, {
        items: [
          {
            label: 'New Aggregate',
            icon: 'ion-plus',
            onclick: m.route.set.bind(m, '/aggregate/new')
          }
        ]
      }) : ''
    ]),
    m(paginationWithSearch, {
      data: ctrl.aggregates,
      newNode: ctrl.newNode,
      dataToShow: ctrl.aggregatesToShow,
      placeHolder: 'Search aggregate',
      itemsPerPage: 30,
      fieldsToSearch: ['name']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              m('colgroup', [
                m('col', {width: '40%'}),
                m('col', {width: '32%'}),
                m('col', {width: '28%'}),
              ]),
              m('thead', [
                m('tr', [ 
                  m('th.ph0.tl', 'Name'),
                  m('th.ph0.tl', 'Function'),
                  m('th.ph0.tl', 'Value'),
                ])
              ]),
              m('tbody', [
                ctrl.aggregatesToShow.map(function (aggregate) {
                  if(!aggregate['@rid']){
                    return m('tr', [
                      m('td.tl.nowrap', [
                        m('label',{style:{'visibility':'hidden'}}, 'No Data'),
                        m('span.ml2', { style: { visibility: 'hidden' } }, [
                          m(rowActionDropdown, { items: [] })
                        ])
                      ]),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                    ])
                  }else{
                    return m('tr', [
                      m('td.tl.nowrap', [
                        m('div.flex.items-center.justify-between.w-100', [
                          m(m.route.Link, {
                            class: 'mr2',
                            href: `/aggregate/${aggregate['@rid'].slice(1)}`
                          }, aggregate.name),
                          m(rowActionDropdown, {
                            align: 'left',
                            items: [
                              {
                                label: 'Edit Aggregate',
                                icon: 'ion-ios-compose',
                                onclick: m.route.set.bind(null, '/aggregate/' + aggregate['@rid'].slice(1))
                              },
                              {
                                label: 'Delete Aggregate',
                                icon: 'ion-ios-trash',
                                class: 'red',
                                onclick: aggregateModal.deleteDialogue.bind(aggregateModal, aggregate)
                              }
                            ]
                          })
                        ])
                      ]),
                      m('td.tl.nowrap', aggregate.func == 'formula' ? aggregate.formula : aggregate.func),
                      aggregate.point ?
                        m(pointTd, {columnRecord: {in: aggregate.point}, tdClass: aggregate.point.unit == 'bool' ? '.bl-0.pl2' : '.bl-0'})
                      :
                        m('td.tl.nowrap'),
                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])

};


module.exports = page;
